/* eslint-disable */
class Product {
	id
	element 
	nav
	accordion

	get min() {
		return this.element.offsetTop
	}

	get max() {
		return this.min + this.element.offsetHeight
	}
	
}
export {Product}
